

import { addAutoPlayForTabs } from '@/assets/js/mutual-fund-and-home-slider.js'
// document.querySelectorAll(".container").forEach((container) => {
    //   const lets_talk_txt = container.querySelector(".lets_talk_txt");
    //   ScrollTrigger.create({
    //     trigger: container,
    //     // scroller: ".demo_scroll",
    //     pin: lets_talk_txt,
    //     pinSpacing: false,
    // start: "top 6.8%",
    //     end: "bottom 12.5%",
    //     // markers: true,
    //   });
    // });

    $(document).on("scroll", onScroll);

    // smooth scroll

    $("nav .nav_list li a").on("click", function (event) {
      $(document).off("scroll");
      var $anchor = $(this);
      $("nav .nav_list li a").each(function () {
        $(this).parent().removeClass("active");
      });
      $anchor.parent().addClass("active");
      var htx = $(".invest_section nav").innerHeight();
      $("html, body")
        .stop()
        .animate(
          {
            scrollTop: $($anchor.attr("href")).offset().top + 2 - htx,
          },
          1000,
          "swing",
          function () {
            $(document).on("scroll", onScroll);
          }
        );

      event.preventDefault();
    });

    // onScroll();
    // adding active link while page scrolling
 function onScroll(event) {
      var hty = $(".invest_section nav").innerHeight();
      var scrollPos = $(document).scrollTop();
      $(" nav .nav_list li a").each(function () {
        var currLink = $(this);
        var refElement = $(currLink.attr("href"));
        if (
          // refElement.position().top + refElement.height() <= scrollPos &&
          refElement.position().top <= scrollPos &&
          refElement.position().top + refElement.height() + hty > scrollPos
        ) {
          $("nav .nav_list li").removeClass("active");
          currLink.parent().addClass("active");
        } 
        else if (scrollPos < 700) {
          $('.nav_list li:first-child').addClass("active");
        } 
        else {
          currLink.parent().removeClass("active");
        }
      });
    }

    $(".market-talk-articles").slick({
      centerMode: true,
      slidesToShow: 3,
      centerPadding: "0px",
      prevArrow: $(".prev-slide-mt"),
      nextArrow: $(".next-slide-mt"),
      lazyLoad: 'ondemand', 
      responsive: [
        {
          breakpoint: 992,
          settings: {
            arrows: false,
            dots: true,
            infinite: false,
            arrows: false,
            centerMode: false,
            centerPadding: "0px",
            variableWidth: false,
            slidesToShow: 1.3,
          },
        },
      ],
    });

    $(".dnt_tke_slider").slick({
      dots: false,
      centerMode: true,
      centerPadding: "177px",
      slidesToShow: 3,
      prevArrow: $(".prev"),
      nextArrow: $(".next"),
      lazyLoad: 'ondemand', 
      responsive: [
        {
          breakpoint: 992,
          settings: {
            arrows: false,
            dots: true,
            infinite: false,
            centerMode: false,
            centerPadding: "0px",
            variableWidth: false,
            autoplay: true,
            autoplaySpeed: 3000,
            slidesToShow: 1.3,
          },
        },
        {
          breakpoint: 480,
          settings: {
            dots: true,
            infinite: false,
            centerMode: false,
            centerPadding: "0px",
            variableWidth: false,
            autoplay: false,
            autoplaySpeed: 3000,
            slidesToShow: 1.3,
          },
        },
      ],
    });


    $("#languages_slide").slick({
      dots: false,
      centerMode: true,
      centerPadding: "177px",
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 8000,
      pauseOnHover: false,
      cssEase: 'linear',  
      prevArrow: $(".prev"),
      nextArrow: $(".next"),
      lazyLoad: 'ondemand', 
      responsive: [
        {
          breakpoint: 992,
          settings: {
            arrows: false,
            dots: true,
            infinite: false,
            centerMode: false,
            centerPadding: "0px",
            variableWidth: false,
            autoplay: true,
            autoplaySpeed: 3000,
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 480,
          settings: {
            dots: true,
            infinite: false,
            centerMode: false,
            centerPadding: "0px",
            variableWidth: false,
            autoplay: true,
            autoplaySpeed: 3000,
            slidesToShow: 2,
          },
        },
      ],
    });

   
    $(".mb_v_press_slider").slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      centerMode: true,
      variableWidth: true,
      arrows: false,
      lazyLoad: 'ondemand', 
      responsive: [
        {
          breakpoint: 992,
          settings: {
            arrows: false,
            dots: true,
            infinite: false,
            arrows: false,
            centerMode: false,
            centerPadding: "0px",
            variableWidth: false,
            autoplay: false,
            autoplaySpeed: 3000,
            slidesToShow: 2.3,
          },
        },
        {
          breakpoint: 480,
          settings: {
            dots: true,
            infinite: false,
            centerMode: false,
            centerPadding: "0px",
            variableWidth: false,
            autoplay: false,
            autoplaySpeed: 3000,
            arrows: false,
            slidesToShow: 1.3,
          },
        },
      ],
    });

    $(".mbl_v_oneplatform_slider").slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      centerMode: true,
      variableWidth: true,
      arrows: false,
      lazyLoad: 'ondemand', 
      responsive: [
        {
          breakpoint: 992,
          settings: {
            arrows: false,
            dots: true,
            infinite: false,
            arrows: false,
            centerMode: false,
            centerPadding: "0px",
            variableWidth: false,
            autoplay: false,
            autoplaySpeed: 3000,
            slidesToShow: 2.3,
          },
        },
        {
          breakpoint: 480,
          settings: {
            dots: true,
            infinite: false,
            centerMode: false,
            centerPadding: "0px",
            variableWidth: false,
            autoplay: false,
            arrows: false,
            autoplaySpeed: 3000,
            slidesToShow: 1.3,
          },
        },
      ],
    });


    $(".home_banner").slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      centerMode: true,
      variableWidth: true,
      arrows: false,
      autoplay: true,
      lazyLoad: 'ondemand', 
      responsive: [
        {
          breakpoint: 992,
          settings: {
            arrows: false,
            dots: true,
            infinite: true,
            arrows: false,
            centerMode: false,
            centerPadding: "0px",
            variableWidth: false,
            autoplay: true,
            autoplaySpeed: 3000,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            arrows: false,
            dots: true,
            infinite: true,
            arrows: false,
            centerMode: false,
            centerPadding: "0px",
            variableWidth: false,
            autoplay: true,
            autoplaySpeed: 3000,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            dots: true,
            infinite: false,
            centerMode: false,
            centerPadding: "0px",
            variableWidth: false,
            autoplay: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            autoplaySpeed: 3000,
          },
        },
      ],
    });

    $(".invest_slider1_contnt").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: ".invest_slider1",
    });
    $(".invest_slider1").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: ".invest_slider1_contnt",
      dots: false,
      centerMode: true,
      centerPadding: "0",
      focusOnSelect: true,
    });
    addAutoPlayForTabs(".int_tab_list");
    addAutoPlayForTabs(".mbl_sec_list"); 